// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.group-accordion {
  border: 3px solid #D1D3D4;
}
.group-accordion .accordion-body-group {
  padding: 32px 48px !important;
}
.group-accordion .group-name-title {
  color: #444343;
  font-size: 18px;
  font-weight: 600;
  margin-right: 8px;
}
.group-accordion .group-student-count {
  color: #444343;
  font-size: 18px;
  font-weight: 450;
  margin-left: 8px;
}
.group-accordion .group-accordion-header-row {
  display: flex;
  justify-content: space-between;
}
.group-accordion .list-group {
  margin-top: 24px;
}
.group-accordion .group-accordion-btn-group {
  display: flex;
  justify-content: flex-end;
}
.group-accordion .epr-subjects-group .subject-card-group {
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  padding: 2px 16px;
  background: #D1D3D4;
  margin-top: 16px;
  border-radius: 5px;
}
.group-accordion .epr-subjects-group .subject-card-group .subject-header-group {
  min-height: 60px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.group-accordion .epr-subjects-group .subject-card-group .subject-header-group .teacher-epr-subject-name-group {
  color: #0A4064;
  font-size: 1.25rem;
  font-weight: 600;
  width: 22%;
}
.group-accordion .epr-subjects-group .subject-card-group .subject-header-group .rating-count-container {
  width: 20%;
}
@media (max-width: 1355px) {
  .group-accordion .epr-subjects-group .subject-card-group .subject-header-group .rating-count-container {
    width: 38%;
  }
}
.group-accordion .epr-subjects-group .subject-card-group .subject-header-group .subject-header-right-group {
  display: flex;
}
.group-accordion .epr-subjects-group .subject-card-group .toggle-subject-comment-btn {
  background-color: transparent;
  color: #0A4064;
  border: none;
  padding: 0px;
  border-radius: 3px;
  font-size: 0.8rem;
  cursor: pointer;
}
.group-accordion .epr-subjects-group .subject-card-group .toggle-subject-comment-btn i {
  margin-right: 6px;
}
.group-accordion .epr-subjects-group .subject-card-group .toggle-subject-comment-btn:hover {
  color: #1786DB;
}
.group-accordion .epr-subjects-group .subject-card-group .subject-comment-textarea {
  border: 1px solid #A7A9AC;
  border-radius: 5px;
  font-size: 14px;
  margin-top: 8px;
  min-height: 60px;
  padding: 5px;
  resize: vertical;
  width: 100%;
}
.group-accordion .epr-subjects-group .subject-card-group .comment-view {
  background-color: #EDF0F1;
  border: 1px solid #A7A9AC;
  border-radius: 5px;
  font-size: 14px;
  font-style: italic;
  margin-top: 8px;
  margin-bottom: 16px;
  min-height: 60px;
  max-height: 80px;
  overflow-y: scroll;
  padding: 5px;
  width: 100%;
}
.group-accordion .epr-subjects-group .permission-indicator {
  width: 80px;
  justify-content: flex-end;
  display: flex;
}
.group-accordion .epr-subjects-group .permission-indicator .permission-indicator-text {
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 0.5rem;
  padding: 0.125rem 0.25rem;
  background: #D5EBFF;
  color: #003A5A;
  width: fit-content;
}
.group-accordion .epr-subjects-group .permission-indicator .edit {
  background: #affebf;
  color: #014b40;
}
.group-accordion .epr-students-table {
  margin-top: 1rem;
}
.group-accordion .epr-students-table table {
  margin-top: 1rem;
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.group-accordion .epr-students-table table thead {
  background-color: #b8d9ec;
  color: #000;
}
.group-accordion .epr-students-table table thead th {
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #0A4064;
  background-color: #c0def0;
  color: #0A4064;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 8px;
}
.group-accordion .epr-students-table table tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}
.group-accordion .epr-students-table table tbody td {
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
}
.group-accordion .epr-students-table table .student-view-cell {
  text-align: center;
}
.group-accordion .epr-students-table table .student-view-cell .centered-button {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/GroupAccordionItem.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,yBAAA;AAUF;AARE;EACE,6BAAA;AAUJ;AAPE;EACE,cDqBK;ECpBL,eAAA;EACA,gBAAA;EACA,iBAAA;AASJ;AANE;EACE,cDcK;ECbL,eAAA;EACA,gBAAA;EACA,gBAAA;AAQJ;AALE;EACE,aAAA;EACA,8BAAA;AAOJ;AAJE;EACE,gBAAA;AAMJ;AAHE;EACE,aAAA;EACA,yBAAA;AAKJ;AADI;ECfA,2CAAA;EDiBE,iBAAA;EACA,mBDfE;ECgBF,gBAAA;EACA,kBAAA;AAGN;AADM;EACE,gBAAA;EAEA,mBAAA;EACA,aAAA;EACA,8BAAA;AAER;AAAQ;EACE,cD7CA;EC8CA,kBAAA;EACA,gBAAA;EACA,UAAA;AAEV;AACQ;EACE,UAAA;AACV;AACU;EAHF;IAII,UAAA;EAEV;AACF;AAGQ;EACE,aAAA;AADV;AAIO;EACG,6BAAA;EACA,cDnEA;ECoEA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAFV;AAKU;EACE,iBAAA;AAHZ;AAMU;EACE,cDvDO;ACmDnB;AAQQ;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AANV;AAQQ;EACE,yBD9EF;EC+EE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AANV;AAWI;EACE,WAAA;EACA,yBAAA;EACA,aAAA;AATN;AAWM;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EAEA,kBAAA;AAVR;AAYM;EACD,mBAAA;EACD,cAAA;AAVJ;AAeE;EACE,gBAAA;AAbJ;AAeI;EACE,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;AAbN;AAeM;EACE,yBAAA;EACA,WAAA;AAbR;AAeQ;EACE,0BAAA;EACA,gCAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAbV;AAkBQ;EACE,yBAAA;AAhBV;AAmBQ;EACE,iBAAA;EACA,6BAAA;AAjBV;AAqBM;EACE,kBAAA;AAnBR;AAqBQ;EACE,aAAA;EACA,uBAAA;AAnBV","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.group-accordion {\n  border: 3px solid $grey1;\n\n  .accordion-body-group {\n    padding: 32px 48px !important;\n  }\n\n  .group-name-title {\n    color: $grey4a;\n    font-size: 18px;\n    font-weight: 600;\n    margin-right: 8px;\n  }\n\n  .group-student-count {\n    color: $grey4a;\n    font-size: 18px;\n    font-weight: 450;\n    margin-left: 8px;\n  }\n\n  .group-accordion-header-row {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .list-group {\n    margin-top: 24px;\n  }\n\n  .group-accordion-btn-group {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .epr-subjects-group {\n    .subject-card-group {\n      @include shadow();\n      padding: 2px 16px;\n      background: $grey1;\n      margin-top: 16px;\n      border-radius: 5px;\n\n      .subject-header-group {\n        min-height: 60px;\n\n        align-items: center;\n        display: flex;\n        justify-content: space-between;\n\n        .teacher-epr-subject-name-group {\n          color: $dk-blue;\n          font-size: 1.25rem;\n          font-weight: 600;\n          width: 22%;\n        }\n\n        .rating-count-container {\n          width: 20%;\n\n          @media (max-width: 1355px) {\n            width: 38%;\n          }\n        }\n\n\n\n        .subject-header-right-group {\n          display: flex;\n        }\n      }\n       .toggle-subject-comment-btn {\n          background-color: transparent;\n          color: $dk-blue;\n          border: none;\n          padding: 0px;\n          border-radius: 3px;\n          font-size: 0.8rem;\n          cursor: pointer;\n\n\n          i {\n            margin-right: 6px;\n          }\n\n          &:hover {\n            color: $pearl-blue-hover;\n          }\n        }\n\n        .subject-comment-textarea {\n          border: 1px solid $grey2;\n          border-radius: 5px;\n          font-size: 14px;\n          margin-top: 8px;\n          min-height: 60px;\n          padding: 5px;\n          resize: vertical;\n          width: 100%;\n        }\n        .comment-view {\n          background-color: $grey0;\n          border: 1px solid $grey2;\n          border-radius: 5px;\n          font-size: 14px;\n          font-style: italic;\n          margin-top: 8px;\n          margin-bottom: 16px;\n          min-height: 60px;\n          max-height: 80px;\n          overflow-y: scroll;\n          padding: 5px;\n          width: 100%;\n        }\n\n    }\n\n    .permission-indicator {\n      width: 80px;\n      justify-content: flex-end;\n      display: flex;\n\n      .permission-indicator-text {\n        font-size: 0.75rem;\n        font-weight: 500;\n        border-radius: 0.5rem;\n        padding: 0.125rem 0.250rem;\n        background: #D5EBFF;\n        color: #003A5A;\n\n        width: fit-content\n      }\n      .edit {\n     background: #affebf;\n    color: #014b40;\n      }\n    }\n  }\n\n  .epr-students-table {\n    margin-top: 1rem;\n\n    table {\n      margin-top: 1rem;\n      width: 100%;\n      border-collapse: collapse;\n      font-size: 14px;\n\n      thead {\n        background-color: #b8d9ec; // approximate light blue\n        color: #000;\n\n        th {\n          border-radius: 5px 5px 0 0;\n          border-bottom: 1px solid $dk-blue;\n          background-color: #c0def0;\n          color: #0A4064;\n          font-size: 0.95rem;\n          font-weight: 500;\n          padding: 8px\n        }\n      }\n\n      tbody {\n        tr:nth-child(even) {\n          background-color: #f5f5f5;\n        }\n\n        td {\n          padding: 8px 12px;\n          border-bottom: 1px solid #ddd;\n        }\n      }\n\n      .student-view-cell {\n        text-align: center;\n\n        .centered-button {\n          display: flex;\n          justify-content: center;\n        }\n      }\n    }\n\n  }\n\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
